import store from '../../../store'
import edit_cameras from './edit_cameras.vue';

window.U_CAMERAS =  new Vue({
	store,
	name : "UPROX_AXON_CAMERAS",
	el: '#sb_cameras',

	data () {
		return {
			showModal: false,
		}
	},
	created () {

	},
	components : {
		edit_cameras
	}
});
